<template>
    <div>
        <b-alert variant="danger" show v-if="!!drafts" class="font-weight-bold">
            <li><b-link @click="$emit('drafts', auction)">{{ drafts }} OPEN </b-link> Shopify Draft Order(s)</li>
        </b-alert>
        <b-alert variant="primary" show>
            <template v-if="auction.status == 'C'">
                <li class="my-0">
                    {{ auction.status == 'M' ? 'Imported' : 'Posted' }}
                    and {{ auction.eb_ListingStatus }}
                    for {{ auction.time_at_status }}
                    <b-link @click="$emit('sales', auction)" v-if="auction.sold_with_children"> with
                        {{ auction.sold_with_children }}
                        units sold.
                    </b-link>
                </li>
                <li v-if="auction.auction_alt_orders && auction.auction_alt_orders.length">Listing has
                    {{ auction.auction_alt_order }} Web/Direct sale(s).
                </li>
                <li v-if="auction.offers && !!auction.offers.length">
                    Listing has had
                    <b-link @click="$emit('offers', auction)">{{ auction.offers.length }} best
                        offer{{ auction.offers.length > 1 ? 's' : '' }}
                    </b-link>
                </li>
                <li v-if="auction.active && auction.qty_remaining">{{ auction.qty_remaining }} listed for sale at
                    {{ auction.eb_CurrentPrice | money }} each
                </li>
                <li v-if="auction.price_log && !!auction.price_log.length">Last reprice from
                    {{ auction.price_log[0].last_price | money }} was {{ auction.price_log[0].created | timediff }}
                </li>
                <li v-if="auction.shopify_draft_orders && !!auction.shopify_draft_orders">
                    <b-link @click="$emit('drafts', auction)">{{ auction.shopify_draft_orders.length }}
                        Shopify</b-link> draft order(s)
                </li>
            </template>
            <template v-else>
                <li>Listing is {{ auction.full_status }}</li>
                <li v-if="!!auction.review_required">Review required</li>
            </template>

            <!-- a quote reserves nothing, so a live quotation against this SKU
                 is otherwise invisible here - the listing can be repriced or
                 ended out from under it. Past ones are the pricing history
                 worth seeing before changing a price. -->
            <li v-if="quotes.open" class="font-weight-bold">
                <b-link @click="viewQuotes('open')">{{ quotes.open }} open
                    quotation{{ quotes.open > 1 ? 's' : '' }}
                </b-link>
                for this SKU
            </li>
            <li v-if="quotes.historic">
                <b-link @click="viewQuotes()">{{ quotes.historic }} past
                    quotation{{ quotes.historic > 1 ? 's' : '' }}
                </b-link>
                for this SKU
            </li>
        </b-alert>
    </div>
</template>

<script>
export default {
    name: "auction-status",
    props: {
        auction: Object,
    },
    computed: {
        drafts() {
            return this.auction &&
                this.auction.shopify_draft_orders &&
                this.auction.shopify_draft_orders.filter(v => (!v.deleted_at && v.status == 'open')).length
        },

        // absent on an older payload, and on any auction the viewer cannot
        // read quotes for - the blocks just do not render
        quotes() {
            return (this.auction && this.auction.quotes) || {open: 0, historic: 0, sku: null}
        }
    },

    methods: {
        /**
         * Hand the SKU to the quote lookup, which already knows how to search
         * by it - an item GLI resolves to quotes carrying a line for that SKU.
         */
        viewQuotes(filter) {
            this.$router.push({
                path: '/quote',
                query: {q: this.quotes.sku, ...(filter ? {filter} : {filter: ''})}
            })
        }
    }
}
</script>

<style scoped>

</style>